import React from "react";

import './HomeAbout.css';

const HomeAbout = () =>
  <section className="HomeAbout jumbotron jumbotron-fluid bg-transparent px-0">
    <div className="container">
    <div className="row mx-0">
      <div className="col-12">
        <div className="row">
          <div className="col-12 px-0 mx-0 pl-3 pl-sm-0">
            <h2 className="text-sm-center mb-3 " data-aos="fade-in" data-aos-easing data-aos-duration="1000" data-aos-once="true">Company History</h2>
          </div>
        </div>
        <div className="row">
          <div className="px-0 col-lg-7 pl-lg-3 col-xl-7">
            <div className="shadow p-1 mb-3">
              <figure className="HomeAbout-image mb-0" data-aos="fade-in" data-aos-easing data-aos-duration="1000" data-aos-once="true"><div className="HomeAbout-image-screen"/></figure>
            </div>
          </div>
          <div className="HomeAbout-description col-lg-5 col-xl-5 px-0 px-lg-4" data-aos="fade-in" data-aos-easing data-aos-duration="1000" data-aos-once="true">
            <div className="shadow p-3 pb-4">
              <p>Since our Company's establishment in 1988 near Washington Square Park, we have provided over three decades of cost-effective copying and printing services to New York businesses and schools and the local neighborhood. </p>
              <p>Currently locating at the heart of Manhattan, we have equipped ourselves with production level digital printers that produce vibrant images in ensuring that all of our products are in top quality. </p>
              <p>We continue to provide professional printing services by following the principles that have guided our success: top-of-the-line customer service, fast turnaround, high quality products, and stable discounted pricing. </p>
              <p>Our team will do the best to establish a long-term business relationship with you.</p>
            </div>
          </div>
        </div>
      </div>  
    </div>
    </div>
  </section>

export default HomeAbout;